import * as React from 'react';
import {generatePath} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import type {FilterObject} from 'nutshell-core/types';

import type {ReportURLParams} from '../../../reports/report-types';
import {useGetInboxStatus} from '../../../setup/text-messaging/graphql/hooks';
import {getPhoneNumber} from '../../../setup/text-messaging/helpers';

import {appHistory} from '../../../../history';

import {BroadcastPage} from './broadcast-page';
import {useGetSmsBroadcast} from './graphql/hooks';
import {PrepareToSendPage} from './prepare-to-send/prepare-to-send-page';

type Props = ContextRouter & {
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'contacts'>;
    onRemoveAllFilters: () => void;
};

export function BroadcastPageWrapper(props: Props) {
    const [isScheduling, setIsScheduling] = React.useState<boolean>(false);
    const [isRescheduling, setIsRescheduling] = React.useState<boolean>(false);
    const activeTab = props.match.params.tab || 'details';
    const {smsBroadcast, isLoading} = useGetSmsBroadcast(props.match.params.broadcastId);
    const {inboxStatus} = useGetInboxStatus();

    const phoneNumber = getPhoneNumber(inboxStatus);

    const onSetSelectedEditorTab = React.useCallback(
        (newTab: string): string =>
            generatePath(props.match.path, {
                broadcastId: props.match.params.broadcastId,
                editionId: props.match.params.editionId,
                tab: newTab,
            }),
        [props.match.path, props.match.params.broadcastId, props.match.params.editionId]
    );

    React.useEffect(() => {
        if (isScheduling) {
            props.history.replace({
                pathname: onSetSelectedEditorTab('prepare'),
                search: props.location.search,
            });
        }
    }, [isScheduling, onSetSelectedEditorTab, props.history, props.location.search]);

    return activeTab === 'prepare' && smsBroadcast ? (
        <PrepareToSendPage
            onClose={() => {
                const url = onSetSelectedEditorTab('details');
                appHistory.push(url);
            }}
            routeToEngagement={() => {
                const url = onSetSelectedEditorTab('engagement');
                appHistory.push(url);
            }}
            edition={smsBroadcast.edition}
            isLoading={false}
            type='BROADCAST'
            from={phoneNumber}
            isScheduling={isScheduling}
            setIsScheduling={setIsScheduling}
            setIsRescheduling={setIsRescheduling}
        />
    ) : (
        <BroadcastPage
            activeTab={activeTab}
            generatePath={onSetSelectedEditorTab}
            broadcast={smsBroadcast}
            isLoading={isLoading}
            setIsScheduling={setIsScheduling}
            setIsRescheduling={setIsRescheduling}
            isRescheduling={isRescheduling}
            onRemoveAllFilters={props.onRemoveAllFilters}
            onParamChange={props.onParamChange}
            urlParams={props.urlParams}
            activeFilters={props.activeFilters}
        />
    );
}
